import React from 'react';
import { OmniIconComponent } from '../../../../shared';

/**
 * CampaignStatusWarningModal
 *
 * Shown when the campaign's mediaocean_status is not "Campaign Sent" and the user
 * attempts to send placements to the Buying System. Asks whether to send the
 * campaign first or proceed with placements only.
 *
 * @param {boolean}  props.isOpen                        - Controls modal visibility
 * @param {Function} props.onClose                       - Called when the user dismisses the modal
 * @param {Function} props.onSendCampaignFirst           - Called when "Yes, send campaign first" is clicked
 * @param {Function} props.onSendPlacementsOnly          - Called when "No, send placements only" is clicked
 */
const CampaignStatusWarningModal = ({
    isOpen,
    onClose,
    onSendCampaignFirst,
    onSendPlacementsOnly,
}) => {
    if (!isOpen) return null;

    return (
        <div className="create-media-order-wizard-overlay" style={{ zIndex: 1001 }}>
            <div className="budget-warning-modal">
                <div className="budget-warning-header">
                    <OmniIconComponent
                        icon-id="omni:informative:alert"
                        style={{ fontSize: '24px', color: '#C87619' }}
                    />
                    <h3>Campaign Not Synced With Prisma</h3>
                    <button
                        className="tertiary"
                        onClick={onClose}
                        style={{ marginLeft: 'auto' }}
                    >
                        <OmniIconComponent
                            icon-id="omni:interactive:close"
                            style={{ fontSize: '24px' }}
                        />
                    </button>
                </div>

                <div className="budget-warning-content">
                    <p className="warning-message">
                        The campaign has been updated but has not yet been synced with Prisma.
                        Would you like to sync the campaign with Prisma before sending the placements?
                    </p>
                </div>

                <div className="budget-warning-actions">
                    <button
                        className="tertiary"
                        onClick={onSendPlacementsOnly}
                    >
                        No, send placements only
                    </button>
                    <button
                        className="primary"
                        onClick={onSendCampaignFirst}
                    >
                        Yes, send campaign first
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CampaignStatusWarningModal;
